import React, { useEffect, useRef, useState } from "react";

export function PlanTableCellFixedHeight({ children }) {
  const thRef = useRef(null);
  const [height, setHeight] = useState(null);

  useEffect(() => {
    if (thRef.current) {
      const el = thRef.current;
      const style = window.getComputedStyle(el);

      const paddingTop = parseFloat(style.paddingTop);
      const paddingBottom = parseFloat(style.paddingBottom);
      const borderTop = parseFloat(style.borderTopWidth);
      const borderBottom = parseFloat(style.borderBottomWidth);

      const contentHeight =
        el.offsetHeight - paddingTop - paddingBottom - borderTop - borderBottom;

      setHeight(contentHeight);
    }
  }, []);

  return (
    <th ref={thRef} className="align-top">
      <div
        className={"flex flex-col"}
        style={{ height: height ? `${height}px` : "auto" }}
      >
        {children}
      </div>
    </th>
  );
}
